export default __webpack_public_path__ + "static/media/scenario-3.0cee7d9a.gif";